import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { RootEpic } from '../types'
import {
  getAuditLogsRequest,
  getAuditLogsSuccess,
  getAuditLogsFailure,
  getLogTypesRequest,
  getLogTypesSuccess,
  getLogTypesFailure,
} from '../actions'

export const fetchAuditLogsEpic: RootEpic = (action$, state$, { fetchAuditLogs }) =>
  action$.pipe(
    filter(isActionOf([getAuditLogsRequest])),
    switchMap(({ payload: { id, client, ...params } }) =>
      from(
        fetchAuditLogs({
          token: state$.value.app.authToken as string,
          id,
          client,
          limit: 10,
          ...state$.value.auditLogs.logs.filters,
          ...params,
        }),
      ).pipe(
        map((response) => getAuditLogsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch audit logs.')
          return of(getAuditLogsFailure(message))
        }),
      ),
    ),
  )

export const fetchLogTypesEpic: RootEpic = (action$, state$, { fetchLogTypes }) =>
  action$.pipe(
    filter(isActionOf([getLogTypesRequest])),
    switchMap(({ payload: { id, client } }) =>
      from(
        fetchLogTypes({
          token: state$.value.app.authToken as string,
          id,
          client,
        }),
      ).pipe(
        map((response) => getLogTypesSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch log types.')
          return of(getLogTypesFailure(message))
        }),
      ),
    ),
  )

export default [fetchAuditLogsEpic, fetchLogTypesEpic]
